/* ===========================================================
   vitaverse-judgeme-zhtw.js
   2026-09-14 修宇指定：商品頁 Judge.me 評論區的英文改成中文。

   為什麼會是英文：
   Judge.me 後台的語言設定是英文（jdgmSettings.locale = "en"、
   shop_locale = "en"、enable_multi_locales_translations = false），
   跟 Shopify 商店語系 zh-TW 不一致，所以小工具整組吐英文。

   ⚠️⚠️ 這是「前台敲打」，不是根本解。
   根本解是進 Judge.me 後台把語言改成繁體中文，那樣官方的整套中文
   會一次到位（含邀評信、電子郵件、後台），也不會被他們改版洗掉。
   這支檔案只能換「下面 SETTINGS / MAP 裡有列到的」那些字。

   ================= 實測踩到的三個坑（別重踏）=================

   坑 1：主力是覆寫 jdgmSettings，不是 DOM 替換。別拿掉 A 段。
   我一度因為「頁面載完後讀 jdgmSettings 回來還是英文」而把 A 段拿掉，
   結果整個失效。正確的理解是：我們覆寫 → Judge.me 用覆寫後的值算圖
   → 之後 loader 才重新指派整個 jdgmSettings。已經算好的 DOM 不會被改回去，
   所以「讀回來是英文」不等於這層沒用。

   坑 2：這支 js 會比 Judge.me 的設定 script 早執行。
   實測：我們在 <head> index 34（緊跟在 shopify-cfh-end 後面），
   Judge.me 的 jdgm-settings-script 在 index 37。所以立即呼叫 applySettings()
   會打空（那時 window.jdgmSettings 還不存在），真正生效的是 DOMContentLoaded
   那一次。不要以為放在 content_for_header 後面就一定拿得到設定。

   坑 3：不可以用 requestAnimationFrame 做防抖。
   rAF 在背景分頁不會觸發，顧客若在背景分頁開商品頁，DOM 那層就死了。
   實測診斷數字：observer 觸發 25 次、scan 却只跑 1 次。已改用 setTimeout。
   （另：寫成 (window.requestAnimationFrame || setTimeout)(fn) 還會被 Shopify
   壓縮成同樣形式，而那在 Chrome 會丟 Illegal invocation。雙重地雷。）

   ⚠️ 2026-09-10 Judge.me 已換過一次新版 widget（class 從 .jdgm-* 變 .jm-*），
      他們再改版或改文案時這支檔案會失效。失效的徵兆就是英文跑回來。

   除錯用：在 console 打 window.__vvJmZhTw，可看各層跑了幾次。
   正常值應該是 applySettings >= 1、scan > 1、swaps > 0。

   DOM 替換層的安全規則：只做「整個文字節點完全相符」的替換，
   絕不做部分比對——顧客寫的評論內文也在這個區塊裡。
   也因此不收錄 and、or 這種短詞——風險大於效益。

   要還原：把 layout/theme.liquid 裡引用這支 js 的那一行刪掉即可。
   =========================================================== */

(function () {
  'use strict';

  var DIAG = { loaded: 1, applySettings: 0, scan: 0, swaps: 0, started: 0, observer: 0 };
  try { window.__vvJmZhTw = DIAG; } catch (e) {}

  /* ===== A. 覆寫 jdgmSettings（主力，別拿掉） ===== */

  var SETTINGS = {
    widget_title: '顧客真實評價',
    widget_no_review_text: '搶先寫下第一則評價',
    widget_open_form_text: '撰寫評價',
    widget_close_form_text: '取消',
    widget_summary_text: '共 {{ number_of_reviews }} 則評價',
    widget_summary_average_rating_text: '{{ average_rating }} / 5',
    widget_open_question_form_text: '提出問題',

    widget_name_field_text: '顯示名稱',
    widget_name_placeholder_text: '顯示名稱',
    widget_email_field_text: '電子郵件',
    widget_email_placeholder_text: '你的電子郵件',
    widget_rating_field_text: '評分',
    widget_review_title_field_text: '評價標題',
    widget_review_title_placeholder_text: '幫這則評價下個標題',
    widget_review_body_field_text: '評價內容',
    widget_review_body_placeholder_text: '在這裡輸入…',
    widget_pictures_field_text: '照片／影片（選填）',
    widget_submit_review_text: '送出評價',
    widget_submit_verified_review_text: '送出評價',
    widget_required_field_error_text: '此欄位為必填。',
    widget_email_field_error_text: '請輸入有效的電子郵件。',
    widget_back_button_text: '上一步',
    widget_next_button_text: '下一步',

    widget_read_more_text: '看更多',
    widget_show_all_link_text: '看全部',
    widget_show_less_link_text: '收合',
    widget_show_more_text: '看更多',
    widget_load_more_text: '載入更多',
    all_reviews_page_load_more_text: '載入更多評價',
    widget_reviewer_anonymous: '匿名',
    widget_today_text: '今天',
    widget_yesterday_text: '昨天',
    widget_verified_text: '已驗證',
    verified_badge_text: '已驗證',
    widget_review_pending_text: '審核中',

    widget_sorting_most_recent_text: '最新',
    widget_sorting_highest_rating_text: '評分最高',
    widget_sorting_lowest_rating_text: '評分最低',
    widget_sorting_with_pictures_text: '只看有照片',
    widget_sorting_most_helpful_text: '最多人覺得有用',

    review_widget_review_word_singular: '則評價',
    review_widget_review_word_plural: '則評價',
    review_widget_voting_label: '這則評價有幫助嗎？',
    review_widget_filters_title: '篩選',
    review_widget_filter_rating_title: '星等',
    review_widget_filter_keyword_title: '關鍵字',
    review_widget_clear_filters_text: '清除篩選',
    review_widget_expand_more_text: '更多',
    all_reviews_widget_v2025_no_review_text: '搶先寫下第一則評價',

    review_content_screen_title_text: '你會給這項商品幾分？',
    review_content_introduction_text: '歡迎和我們分享你的使用心得。',
    store_review_form_title_text: '你會給這間商店幾分？',
    store_review_form_introduction_text: '歡迎和我們分享你的購物體驗。',
    one_star_review_guidance_text: '不滿意',
    five_star_review_guidance_text: '很滿意',
    customer_information_screen_title_text: '關於你',
    customer_information_introduction_text: '請留下你的基本資料。',
    review_submitted_screen_title_text: '感謝你的評價！',
    review_submitted_screen_thank_you_text: '我們正在處理，稍後就會顯示在商店頁面上。',
    review_submitted_screen_email_verification_text: '請點擊我們剛寄出的信件連結確認你的電子郵件，這能幫助我們確保評價的真實性。',
    confirm_email_screen_title_text: '確認你的電子郵件',
    check_email_screen_title_text: '請檢查你的信箱',
    review_submitted_request_store_review_text: '想順便分享這次的購物體驗嗎？',
    store_review_screen_title_text: '想順便分享這次的購物體驗嗎？',
    store_review_introduction_text: '你的意見對我們很重要，歡迎留下任何想法或建議。',
    reviewer_media_screen_title_picture_or_video_text: '分享照片或影片',
    reviewer_media_introduction_picture_or_video_text: '可以上傳照片或影片，讓評價更有說服力。',
    reviewer_media_screen_title_picture_text: '分享照片',
    reviewer_media_introduction_picture_text: '可以上傳照片，讓評價更有說服力。',
    reviewer_media_screen_title_video_text: '分享影片',
    reviewer_media_introduction_video_text: '可以上傳影片，讓評價更有說服力。',
    reviewer_media_youtube_url_text: '在這裡貼上 YouTube 影片網址',
    advanced_settings_next_step_button_text: '下一步',
    advanced_settings_close_review_button_text: '關閉',
    write_review_flow_required_text: '必填',
    write_review_flow_required_field_error_text: '此欄位為必填',
    write_review_flow_invalid_email_error_text: '請輸入有效的電子郵件',
    write_review_flow_privacy_message_text: '我們會保護你的隱私。',
    write_review_flow_anonymous_text: '以匿名方式發表',
    write_review_flow_visibility_text: '這項資訊不會公開給其他顧客。',
    write_review_flow_media_upload_text: '<b>點擊上傳</b>或拖曳檔案到這裡',

    /* 條款聲明：Judge.me 會把這段當 HTML 輸出，所以連結要一起給 */
    write_review_flow_gdpr_statement: '我們只會在必要時就你的評價與你聯繫。送出評價即表示你同意我們的 <a href=\'https://judge.me/terms\' target=\'_blank\' rel=\'nofollow noopener\'>服務條款</a> 與 <a href=\'https://judge.me/privacy\' target=\'_blank\' rel=\'nofollow noopener\'>隱私權政策</a>。',
    widget_gdpr_statement: '資料使用方式：我們只會在必要時就你留下的評價與你聯繫。送出評價即表示你同意 Judge.me 的 <a href=\'https://judge.me/terms\' target=\'_blank\' rel=\'nofollow noopener\'>服務條款</a>、<a href=\'https://judge.me/privacy\' target=\'_blank\' rel=\'nofollow noopener\'>隱私權</a> 與 <a href=\'https://judge.me/content-policy\' target=\'_blank\' rel=\'nofollow noopener\'>內容</a> 政策。'
  };

  function applySettings() {
    try {
      var s = window.jdgmSettings;
      if (!s) return;
      for (var k in SETTINGS) {
        if (Object.prototype.hasOwnProperty.call(SETTINGS, k) && k in s) s[k] = SETTINGS[k];
      }
      DIAG.applySettings++;
    } catch (e) {}
  }

  applySettings();

  /* ===== B. DOM 文字替換（備援） ===== */

  var MAP = {
    'Customer Reviews': '顧客真實評價',
    'Be the first to write a review': '搶先寫下第一則評價',
    'Write a review': '撰寫評價',
    'Ask a question': '提出問題',
    'Load More': '載入更多',
    'Load More Reviews': '載入更多評價',
    'Show more': '看更多',
    'Show less': '收合',
    'Show all': '看全部',
    'Read more': '看更多',
    'Verified': '已驗證',
    'Anonymous': '匿名',
    'Pending': '審核中',
    'Today': '今天',
    'Yesterday': '昨天',
    'Helpful?': '這則評價有幫助嗎？',
    'Most Recent': '最新',
    'Highest Rating': '評分最高',
    'Lowest Rating': '評分最低',
    'Only Pictures': '只看有照片',
    'Most Helpful': '最多人覺得有用',
    'Filters': '篩選',
    'Rating': '評分',
    'Keyword': '關鍵字',
    'Clear filters': '清除篩選',
    'More': '更多',
    'Back': '上一步',

    'How would you rate this product?': '你會給這項商品幾分？',
    'We would love it if you would share a bit about your experience.': '歡迎和我們分享你的使用心得。',
    'Poor': '不滿意',
    'Great': '很滿意',
    'Review content': '評價內容',
    'Review content (Required)': '評價內容（必填）',
    'Review Title': '評價標題',
    'Start writing here...': '在這裡輸入…',
    'Required': '必填',
    '(Required)': '（必填）',

    'About you': '關於你',
    'Please tell us more about you.': '請留下你的基本資料。',
    'Display name': '顯示名稱',
    'Display name (Required)': '顯示名稱（必填）',
    'Email address': '電子郵件',
    'Email address (Required)': '電子郵件（必填）',
    'Your email address': '你的電子郵件',
    'We respect your privacy.': '我們會保護你的隱私。',
    "This won't be visible to other customers.": '這項資訊不會公開給其他顧客。',
    'Post review as anonymous': '以匿名方式發表',
    'This field is required.': '此欄位為必填。',
    'This field is required': '此欄位為必填',
    'Please enter a valid email address.': '請輸入有效的電子郵件。',
    'Please enter a valid email address': '請輸入有效的電子郵件',

    'Share a picture or video': '分享照片或影片',
    'Upload a photo or video to support your review.': '可以上傳照片或影片，讓評價更有說服力。',
    'Share a picture': '分享照片',
    'Upload a photo to support your review.': '可以上傳照片，讓評價更有說服力。',
    'Share a video': '分享影片',
    'Upload a video to support your review.': '可以上傳影片，讓評價更有說服力。',
    'Click to upload': '點擊上傳',
    'or drag and drop': '或拖曳檔案到這裡',
    'YouTube URL': 'YouTube 影片網址',
    'Paste your Youtube URL here': '在這裡貼上 YouTube 影片網址',
    'Picture/Video (optional)': '照片／影片（選填）',

    'Next': '下一步',
    'Close': '關閉',
    'Cancel': '取消',
    'Cancel review': '取消',
    'Submit Review': '送出評價',
    'Submit Verified Review': '送出評價',
    'Review Submitted!': '評價已送出！',
    'Thanks for your review!': '感謝你的評價！',
    'We are processing it and it will appear on the store soon.': '我們正在處理，稍後就會顯示在商店頁面上。',
    'Please confirm your email by clicking the link we just sent you. This helps us keep reviews authentic.': '請點擊我們剛寄出的信件連結以確認你的電子郵件，這能幫助我們確保評價的真實性。',
    'Confirm your email': '確認你的電子郵件',
    'Check your email': '請檢查你的信箱',

    'Would you like to share your experience of shopping with us?': '想順便分享這次的購物體驗嗎？',
    'We value your feedback and use it to improve. Please share any thoughts or suggestions you have.': '你的意見對我們很重要，歡迎留下任何想法或建議。',
    'How would you rate this store?': '你會給這間商店幾分？',
    'Write a Store Review': '撰寫商店評價',

    "We'll only contact you about your review if necessary. By submitting your review, you agree to our": '我們只會在必要時就你的評價與你聯繫。送出評價即表示你同意我們的',
    'terms and conditions': '服務條款',
    'privacy policy': '隱私權政策'
  };

  var ROOTS = '.jm-review-widget, .jdgm-widget, .jdgm-review-widget, .jdgm-review-widget-modal, .jdgm-write-review-modal';

  function swap(root) {
    if (!root || root.nodeType !== 1) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var raw = node.nodeValue;
      if (!raw) continue;
      var key = raw.trim();
      if (!key) continue;
      if (Object.prototype.hasOwnProperty.call(MAP, key)) {
        node.nodeValue = raw.replace(key, MAP[key]);
        DIAG.swaps++;
      }
    }
  }

  function scan() {
    DIAG.scan++;
    var roots = document.querySelectorAll(ROOTS);
    for (var i = 0; i < roots.length; i++) swap(roots[i]);
  }

  var queued = false;
  function scheduleScan() {
    if (queued) return;
    queued = true;
    /* ⚠️ 必須用 setTimeout，rAF 在背景分頁不會觸發（見檔頭坑 3） */
    window.setTimeout(function () { queued = false; scan(); }, 0);
  }

  function start() {
    DIAG.started = 1;
    applySettings();
    scan();
    try {
      new MutationObserver(function () {
        DIAG.observer++;
        scheduleScan();
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
    /* 彈窗是點下去才算圖的，所以每次點擊前先把設定再覆寫一次 */
    document.addEventListener('click', function () {
      applySettings();
      scheduleScan();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
